// Settings.js
import React, { useEffect, useState } from "react";
import { Box, SimpleGrid } from "@chakra-ui/react";
import axios from "axios";
import CVETable from "views/admin/cveTable/components/CVETable";
import { columnsCVETable } from "views/admin/cveTable/variables/columnsData";
export default function Settings() {
  const [cveData, setCveData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const uri = process.env.REACT_APP_AWS_FLASK_BASE_URI + "/compute_results";
    console.log(uri);
    const data = {
      "api_key": process.env.REACT_APP_AWS_FLASK_API_KEY
    }
    axios.post(uri, data)
      .then(response => {
        console.log("Fetched CVE Data: ", response.data); // Log fetched data
        setCveData(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error("There was an error fetching the CVE data - Settings page!", error);
        setError(error);
        setLoading(false);
      });
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error loading data: {error.message}</p>;

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        mb='20px'
        columns={{ sm: 1, md: 2 }}
        spacing={{ base: "20px", xl: "20px" }}>
      </SimpleGrid>
      <CVETable columnsData={columnsCVETable} tableData={cveData} />
    </Box>
  );
}
